import React, { useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import '../styles/EmployeeMaster.css';
import HolidayTable from '../components/HolidayTable';
import 'react-toastify/dist/ReactToastify.css';
const Holiday = () => {
     const [employees, setEmployees] = useState([]);
     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/holiday/add';

     const handleAddClick = () => {

          navigate('/holiday/add');
     };

     const handleCloseModal = () => {
          navigate('/holiday');
     };

     return (
          <>  <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />
               <div className="employee-master-page">
                    <div className="employee-header">
                         <h2>Holiday Master</h2>
                         <button className="add-employee-btn" onClick={handleAddClick}>
                              Add Holiday
                         </button>
                    </div>

                    <HolidayTable />
               </div>
          </>
     );
};

export default Holiday;